import { useQuery } from "@tanstack/react-query"

import { bffApi } from "@/queries/apiClient"

// Temporary query to get user public id, should be removed when we have a proper user context from app shell
type User = {
  publicId: string
}

const useUserQuery = () => {
  return useQuery<string | null>({
    queryKey: ["user"],
    queryFn: async () => {
      const res = await bffApi.get<User>("/user")
      return res.data?.publicId ?? null
    },
  })
}

export default useUserQuery
